import React from "react";
import {
  BlockWrapper,
  defineBlock,
  smartProps,
  useEditor,
} from "@smartfire/js-block-engine";
import { useTranslation } from "react-i18next";
import { EditableText } from "@smartfire/components";
import { ReactComponent as ChefHat } from "./assets/chef_hat.svg";
import { ReactComponent as TimeSpent } from "./assets/time_spent.svg";
import { ReactComponent as Users } from "./assets/users.svg";
import style from "./style.module.scss";

export const RecipeInfo = ({ difficulty, portions, time }) => {
  const { isEditing } = useEditor();
  const { t } = useTranslation();

  return (
    <BlockWrapper.Div className={style.block}>
      <div className={style.item}>
        <ChefHat />
        {(isEditing || difficulty) && (
          <EditableText
            smartProp={"difficulty"}
            tagName={"p"}
            className={style.difficulty}
            placeholder={`${t("Difficulty")}...`}
          />
        )}
      </div>
      <div className={style.item}>
        <Users />
        {(isEditing || portions) && (
          <EditableText
            smartProp={"portions"}
            tagName={"p"}
            className={style.portions}
            placeholder={`${t("Portions")}...`}
          />
        )}
      </div>
      <div className={style.item}>
        <TimeSpent />
        {(isEditing || time) && (
          <EditableText
            smartProp={"time"}
            tagName={"p"}
            className={style.time}
            placeholder={`${t("Time")}...`}
          />
        )}
      </div>
    </BlockWrapper.Div>
  );
};

export default defineBlock({
  Block: RecipeInfo,
  setup: {
    title: "Recipe Info",
  },
  smartProps: {
    difficulty: smartProps.string.withDefault(""),
    portions: smartProps.string.withDefault(""),
    time: smartProps.string.withDefault(""),
  },
});
